﻿/*-------------------------------------------------------
'   @module: CMS / Content-Builder
'---------------------------------------------------------*/

import { opaccLogPlugin } from './vendor/script/opacc.static.js';

export class CMS {

    constructor() {
        
        /* Init */
        let cmsContentSelector = ".opacc-cms-content";
        let cmsWrappers = document.querySelectorAll(cmsContentSelector);
        let cmsWrapperIdList = [];
        let bolPageBuilderEditMode = false;

        /* Alle auf der Page vorhanden PageBuilder-Containers loopen */
        cmsWrappers.forEach(function(cmsWrappeObject) {

            /* Ids der Content-Wrappers zwischenspeichern */
            cmsWrapperIdList.push(cmsWrappeObject.id);

            /* EditMode zwischenspeichern */
            let editMode = cmsWrappeObject.dataset.editmode;

            /* Prüfen, ob EditMode aktiv ist */
            if (editMode == "true") {
                bolPageBuilderEditMode = true;
            }
        });

        /* Falls EditMode aktiv ist --> PageBuilder initialisieren */
        if (bolPageBuilderEditMode) {
            this.InitContentBuilder(cmsWrapperIdList);
        }
        
        /* EventListeners für 'Speichern'-Button */
        this.AttachEventListener(this);
    }

    AttachEventListener(cms) {
        
        /* Alle 'Speichern'-Buttons auslesen */
        let cmsSaveButtonSelector = ".opacc-cms-btn-save";
        let cmsSaveButtons = document.querySelectorAll(cmsSaveButtonSelector);

        /* EventListeners für 'Speichern'-Button binden */
        cmsSaveButtons.forEach(function(cmsSaveButtonObject) {

            cmsSaveButtonObject.addEventListener("click", e => {
                $(cmsSaveButtonObject).addClass("is-progress");
                cms.SavePageBuilderContent();
            });
        });
    }

    InitContentBuilder(cmsWrapperIdList) {
      
        /* String mit Ids der Content-Wrappers zusammenstellen, jQuery-Selector $('.opacc-cms-content') funktioniert nicht, wie auch Loop der einzelnen Objekte! */
        var cmsWrapperIdString = "";

        for (var i = 0; i < cmsWrapperIdList.length; i++) {

            if (i == (cmsWrapperIdList.length - 1)) {
                cmsWrapperIdString += "#" + cmsWrapperIdList[i];
            } else {
                cmsWrapperIdString += "#" + cmsWrapperIdList[i] + ", ";
            }
        }

        /* PageBuilder initialisieren */
        $(cmsWrapperIdString).contentbuilder({
            snippetFile: '/webportal/config/layout/include/cms/snippets/snippets.html',
            snippetOpen: true,
            toolbar: 'left',
            snippetCategories: [ [ 1, "Electrosuisse" ]]
        });
    }

    SavePageBuilderContent() {

        let cmsContentSelector = ".opacc-cms-content";
        let cmsWrappers = document.querySelectorAll(cmsContentSelector);
        
        /* Alle auf der Page vorhanden PageBuilder-Containers loopen --> Daten speichern */
        cmsWrappers.forEach(function(cmsWrapperObject) {

            let cmsWrapperContent = $(cmsWrapperObject).data("contentbuilder").html();

            let data = {
                sitename : cmsWrapperObject.dataset.site,
                sitecontent : htmlEncode(cmsWrapperContent)
            }
            
            $.ajax({

                method: "POST",
                url: cmsWrapperObject.dataset.save,
                data: data

            }).done(function(response) {

                /* Layout der 'Speichern'-Buttons zurücksetzen */
                ResetContentBuilderSaveButtons();     
            });
        });

        /* Meldung ausgeben */
        opaccLogPlugin.showInfo("Die PageBuilder-Inhalte wurden gespeichert!");
    }
}

function ResetContentBuilderSaveButtons() {

    let cmsSaveButtonSelector = ".opacc-cms-btn-save";
    let cmsSaveButtons = document.querySelectorAll(cmsSaveButtonSelector);

    cmsSaveButtons.forEach(function(cmsSaveButtonObject) {
        $(cmsSaveButtonObject).removeClass("is-progress");
    });
}
  
function htmlEncode(value){
    return $('<div/>').text(value).html();
}
  
function htmlDecode(value){
    return $('<div/>').html(value).text();
}
  
new CMS();




